import baseApi from "../api/baseApi";

const demoSessionApi = baseApi.injectEndpoints({
  endpoints: (builder) => ({
    getAllDemoSessionRequests: builder.query({
      query: ({ status } = {}) => {
        const paramsObj = {};

        if (status) {
          paramsObj.status = status;
        }

        const queryString = new URLSearchParams(paramsObj).toString();

        return {
          url: queryString
            ? `/demosession/getAllDemoSessionRequests?${queryString}`
            : "/demosession/getAllDemoSessionRequests",
          method: "GET",
          credentials: "include",
        };
      },
    }),

    getAllSessions: builder.query({
      query: ({
        page,
        limit,
        status,
        search,
        instructorId,
        courseId,
        categoryId,
        startDate,
        endDate,
      } = {}) => {
        const paramsObj = {};

        if (page) paramsObj.page = page;
        if (limit) paramsObj.limit = limit;
        if (status) paramsObj.status = status;
        if (search) paramsObj.search = search;
        if (instructorId) paramsObj.instructorId = instructorId;
        if (courseId) paramsObj.courseId = courseId;
        if (categoryId) paramsObj.categoryId = categoryId;
        if (startDate) paramsObj.startDate = startDate;
        if (endDate) paramsObj.endDate = endDate;

        const queryString = new URLSearchParams(paramsObj).toString();

        return {
          url: queryString
            ? `/coursesession/allSessions?${queryString}`
            : "/coursesession/allSessions",
          method: "GET",
          credentials: "include",
        };
      },
    }),

    approveAndAssignInstructor: builder.mutation({
      query: ({ id, demoSessionLink, instructorId }) => ({
        url: `/demosession/approveAndAssignInstructor/${id}`,
        method: "PATCH",
        body: {
          demoSessionLink,
          instructorId,
        },
      }),
    }),
  }),
});

export const {
  useGetAllDemoSessionRequestsQuery,
  useApproveAndAssignInstructorMutation,
  useGetAllSessionsQuery,
  useLazyGetAllSessionsQuery,
} = demoSessionApi;
